import type { BaoCaoSoDuQuyVaNganHangRow, BaoCaoSoDuQuyVaNganHangSearchParams } from '@/types/schemas';
import { useReportData } from '@/hooks/queries';

const generateMockData = (): BaoCaoSoDuQuyVaNganHangRow[] => {
  return [
    {
      tk_data: { code: '111', name: 'Tiền mặt VNĐ' },
      du: 15000000,
      du_nt: 0
    },
    {
      tk_data: { code: '112', name: 'Tiền gửi ngân hàng' },
      du: 500000000,
      du_nt: 10000
    },
    {
      tk_data: { code: '131', name: 'Phải thu khách hàng' },
      du: 75000000,
      du_nt: 0
    },
    {
      tk_data: { code: '331', name: 'Phải trả người bán' },
      du: -25000000,
      du_nt: -500
    },
    {
      tk_data: { code: '411', name: 'Vốn kinh doanh' },
      du: 1000000000,
      du_nt: 0
    }
  ];
};

export function useReport(searchParams: BaoCaoSoDuQuyVaNganHangSearchParams) {
  return useReportData<BaoCaoSoDuQuyVaNganHangRow, BaoCaoSoDuQuyVaNganHangSearchParams>({
    endpoint: 'tien-mat/so-quy/bao-cao-so-du-quy-va-ngan-hang/',
    useMock: true,
    mockDataGenerator: generateMockData,
    searchParams: searchParams
  });
}
